import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { OrgaoSetorialista } from '../models/orgao-setorialista.model';

@Injectable({
  providedIn: 'root',
})
export class OrgaoSetorialistaService extends BaseService<OrgaoSetorialista> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/orgao-setorialista';
  }

}
